import { getCardCMC } from 'utils/GetCardCMC'

import { ChartDatum } from 'components/deckPage/charts/BarChart'
import { CardType } from 'types/deck'

export function calculateManaCurve(cards: CardType[]): {
  data: ChartDatum[]
  avgCmc: number
  totalManaValue: number
  isEmptyChart: boolean
} {
  let totalCards = 0
  let cumulativeManaValue = 0
  let isEmptyChart = true

  const manaCurve: ChartDatum[] = [
    { label: '0', count: 0 },
    { label: '1', count: 0 },
    { label: '2', count: 0 },
    { label: '3', count: 0 },
    { label: '4', count: 0 },
    { label: '5', count: 0 },
    { label: '6', count: 0 },
    { label: '7', count: 0 },
    { label: '8+', count: 0 },
  ]

  for (const card of cards) {
    const cmc = getCardCMC(card)
    const cmcCount = card.qty

    if (card.types.includes('Land') && !cmc) continue

    isEmptyChart = false

    let curveIndex = cmc < 8 ? cmc : 8

    manaCurve[curveIndex].count += cmcCount

    cumulativeManaValue += cmc * cmcCount
    totalCards += card.qty
  }

  return {
    data: manaCurve,
    avgCmc: cumulativeManaValue / totalCards,
    totalManaValue: cumulativeManaValue,
    isEmptyChart,
  }
}
